// 测试数据
export const test = {
  'meta': {
    'code': 2000,
    'internal_message': [],
    'user_message': null,
    'notice': null
  },
  'dataset': {
    'count': 1000,
    'datalist|10': [{
      'id|+1': 1,
      'code': /[a-z]{2}[A-Z]{2}[0-9]/,
      'name|1-10': 10,
      'sort|+1': 1
    }]
  }
};

export const testCompany = {
  'meta': {
    'code': 2000,
    'internal_message': [],
    'user_message': null,
    'notice': null
  },
  'dataset': {
    'count': 1000,
    'datalist|10': [{
      'id|+1': 1,
      'company': /[a-z]{2}[A-Z]{2}/,
      'name': /[a-z]{8}/,
      'phone': /^1(5|3|7|8)[0-9]{9}$/,
      'manage_category': /[a-z]{8}/,
      'manage_attribute': /[a-z]{8}/,
      'is_local|1': true
    }]
  }
};

export const testByGet = {
  'meta': {
    'code': 2000,
    'internal_message': [],
    'user_message': null,
    'notice': null
  },
  'dataset': {
    data: {
      'id': 1,
      'code': '我是code',
      'name': '我是name'
    }
  }
};

// eslint-disable-next-line camelcase
export const list = {
  'meta': {
    'code': 2000,
    'internal_message': [],
    'user_message': null,
    'notice': null
  },
  'dataset': {
    'datalist': [
      {
        'id': 6,
        'code': 'XH1911034a5a',
        'gen_time': '2019-11-03 17:25:46',
        'recipient_phone': null,
        'recipient': 'wwqqtetsrecipient',
        'amount': 10,
        'builtin_stock_order_status_value': '待付款',
        'builtin_stock_order_status': 1,
        'pay_method': '未支付'
      }
    ],
    'count': 1
  }
};

// eslint-disable-next-line camelcase
export const details = {
  'meta': {
    'code': 2000,
    'internal_message': [],
    'user_message': null,
    'notice': null
  },
  'dataset': {
    'data': {
      'id': 6,
      'builtin_stock_order_status': 1,
      'builtin_stock_order_status_value': '待付款',
      'base_info': {
        'code': 'XH1911034a5a',
        'order_type': '现货订单',
        'user_phone': null,
        'pay_method': '未支付',
        'logistics_company': null,
        'logistics_number': null
      },
      'receive_info': {
        'recipient': 'wwqqtetsrecipient',
        'recipient_phone': null,
        'recipient_address': 'province001city001dist001wwqqtets'
      },
      'product_info': [
        {
          'id': 5,
          'order_code': 'XH1911034a5a',
          'order_id': 6,
          'product_id': 15,
          'product_name': '2121',
          'product_icon_url': '',
          'color_id': 1,
          'color_name': 'color001',
          'size_id': 1,
          'size_name': 'size001',
          'count': 2,
          'price': 10,
          'gen_time': '2019-11-03 17:25:46',
          'modified_time': '2019-11-03 17:25:46',
          'gen_user_id': 0,
          'modified_user_id': 0,
          'status': 1,
          'status_value': '已启用',
          'org_id': null,
          'delete_status': 0,
          'delete_status_value': '未删除',
          'brand_name': '1212'
        }
      ],
      'fee_info': {
        'product_fee': 100,
        'logistics_fee': 3,
        'order_fee': 103,
        'real_fee': 103
      },
      'comments': ''
    }
  }
};
